import { Button } from '@corratech/pylot-ui'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

interface StoreSwitcherProps {
    footerSwitcher: boolean
}

const StoreSwitcher = ({ footerSwitcher }: StoreSwitcherProps) => {
    const router = useRouter()
    const { asPath } = router
    const { t } = useTranslation(['common'])
    const newLocale = router.locale == 'en' ? 'ar' : 'en'

    const buttonText = footerSwitcher
        ? t(`footerLocaleNames|${newLocale}`)
        : t(`localeNames|${newLocale}`)

    const handleClick = () => {
        const baseUrl = window.location.origin

        const newUrl = `${baseUrl}/${newLocale}${asPath}`

        document.cookie = `NEXT_LOCALE=${newLocale}; max-age=31536000; path=/`
        window.location.href = newUrl
    }
    return (
        <Button
            variant="link"
            className="language-switcher_button"
            onClick={handleClick}
        >
            <span>{buttonText}</span>
        </Button>
    )
}

export default StoreSwitcher
